module.exports = __webpack_public_path__ + "img/about-promo-bg-900-599.5cef80b.jpg";